import { render } from "./Tabs.vue?vue&type=template&id=7af2e6e2&scoped=true&ts=true"
import script from "./ts/tabs/tabsHelper.ts?vue&type=script&lang=ts"
export * from "./ts/tabs/tabsHelper.ts?vue&type=script&lang=ts"

import "./Tabs.vue?vue&type=style&index=0&id=7af2e6e2&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af2e6e2"]])

export default __exports__